import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import UtilityBar from "./UtilityBar";
import WhatsAppFloat from "./WhatsAppFloat";
import MobileStickyBar from "./MobileStickyBar";
import QuoteProvider, { useQuote } from "./QuoteProvider";
import { Toaster } from "sonner";
import api from "@/lib/api";
import { organizationSchema, localBusinessSchema } from "@/lib/schema";

function InnerLayout() {
  const { openQuote } = useQuote();
  const loc = useLocation();
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);

  useEffect(() => {
    if (!settings || !settings.business_name) return;
    const scripts = [organizationSchema(settings), localBusinessSchema(settings)]
      .map((obj) => {
        const s = document.createElement("script");
        s.type = "application/ld+json";
        s.setAttribute("data-seo-site", "1");
        s.text = JSON.stringify(obj);
        document.head.appendChild(s);
        return s;
      });
    return () => scripts.forEach((s) => s.remove());
  }, [settings]);

  return (
    <div className="App pb-16 lg:pb-0">
      <a href="#main-content" className="sr-only focus:not-sr-only fixed top-2 left-2 bg-[#0F2747] text-white px-3 py-1.5 z-[60]">Skip to content</a>
      <UtilityBar settings={settings} />
      <Navbar onQuoteClick={() => openQuote()} />
      <main id="main-content"><Outlet context={{ settings }} /></main>
      <Footer settings={settings} />
      <WhatsAppFloat number={settings.whatsapp} />
      <MobileStickyBar />
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default function Layout() {
  return (
    <QuoteProvider>
      <InnerLayout />
    </QuoteProvider>
  );
}
